export const colors = {
    ercPrimary: '#0B7077',
    ercSuccess: '#35C655',
    ercWarning: '#F6C61B',
    ercError: '#EE0202',
    ercWhite: '#FFF',
    ercButtonPrimary: '#00296B',
    ercButtonHover: '#0749AB',
    ercButtonYellow: '#FFD600',
    ercButtonFaint: '#DFFEFE',
    ercButtonPressed: '#49BBBD',
    ercButtonDisabaled: '#CCEBEC',
}